export const updateLanguages = (languages: string[]) => ({ languages });
export const updateProcessCategories = (processCategories: string[]) => ({ processCategories });
export const updateIndustryIds = (industryIds: string[]) => ({ industryIds, materialCategoryIds: [] });
export const updateSpecialtyIds = (specialtyIds: string[]) => ({ specialtyIds });
export const updateMaterialCategoryIds = (materialCategoryIds: string[]) => ({ materialCategoryIds });
